import Icon from '../components/Icon.vue'

Icon.register({
  sync: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440.6 12.6c0-0.2 0-0.4 0-0.6 0-6.6 5.4-12 12-12h47.4c6.6 0 12 5.4 12 12v200.3c0 6.6-5.4 12-12 12h-200.2c-6.6 0-12-5.4-12-12v-47.4 0c0-6.6 5.4-12 12-12 0.2 0 0.4 0 0.6 0l101.5 4.9c-28.9-42.9-94.3-77.8-146-77.8-76.5 0-153.1 60.3-171 134.7-1.2 5.1-6.4 9.3-11.7 9.3h-49c-6.6 0-12-5.4-12-12 0-0.6 0.1-1.6 0.2-2.2 21.6-114.9 122.4-201.8 243.5-201.8h0.3c63.2 0 147.7 39.1 188.5 87.3zM255.8 432c76.5 0 153.1-60.4 171-134.7 1.2-5.1 6.4-9.3 11.7-9.3h49c6.6 0 12 5.4 12 12 0 0.6-0.1 1.6-0.2 2.2-21.6 114.9-122.4 201.8-243.6 201.8h-0.2c-63.1 0-147.5-39.1-188.4-87.2l4.1 82.6c0 0.2 0 0.4 0 0.6 0 6.6-5.4 12-12 12h0-47.3c-6.6 0-12-5.4-12-12v-200.3c0-6.6 5.4-12 12-12h200.2c6.6 0 12 5.4 12 12v47.4 0c0 6.6-5.4 12-12 12-0.2 0-0.4 0-0.6 0l-101.8-4.9c28.8 42.9 94.1 77.8 145.8 77.8h0.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sync.js
// module id = 1973
// module chunks = 0